import getCsrfToken from '../../lib/csrfToken';
import User from '../containers/User';

async function createUser(data: User, dryRun: boolean) {
  const formData = data.buildFormData();
  formData.append('dry_run', dryRun.toString())

  const headers: HeadersInit = new Headers();
  const token = getCsrfToken();
  if (token !== undefined) {
    headers.set('X-CSRFToken', token);
  }

  const resp = await fetch('/api/users/users/', {
    method: 'POST',
    headers: headers,
    body: formData
  });

  const json = await resp.json();
  // data.load(json);
  return [resp.status, json];
}

export default createUser;
